<div class="jumbotron centered-text">
  <ng-container *ngIf="data.confirm?.updatedCount === 1">Byl upraven {{data.confirm.updatedCount}} z {{data.confirm.totalCount}} záborů.</ng-container>
  <ng-container *ngIf="data.confirm?.updatedCount >= 2 && data.confirm?.updatedCount <= 4">Byly upraveny {{data.confirm.updatedCount}} z {{data.confirm.totalCount}} záborů.</ng-container>
  <ng-container *ngIf="!data.confirm?.updatedCount || data.confirm?.updatedCount >= 5">Bylo upraveno {{data.confirm?.updatedCount || 0}} z {{data.confirm.totalCount}} záborů.</ng-container>
  <ng-container *ngIf="data.confirm?.occupationSolutionType">
    <div class="centered-text mt-10">
      Typ řešení: <strong>{{ data.confirm.occupationSolutionType.name }}</strong>
    </div>
    <ng-container *ngIf="data.confirm.occupationSolutionType.key === 'CANCELLED' && data.confirm.finalSolutionReasonCancellation">
      <div class="centered-text mt-10">
        Důvod zrušení: <em>{{ data.confirm.finalSolutionReasonCancellation }}</em>
      </div>
    </ng-container>
  </ng-container>
  <div class="centered-text mt-10">Přejete si provést další hromadnou operaci nad zvoleným seznamem záborů?</div>
  <div class="centered-text mt-10">
    <gmt-button [clickAction]="newOperation">Ano</gmt-button>
    <gmt-button [clickAction]="goToList">Ne</gmt-button>
  </div>
</div>
<fieldset *ngIf="data.confirm?.failedGroups?.length">
  <legend>Neupravené zábory a chybová hlášení</legend>
  <div *ngFor="let group of data.confirm.failedGroups">
    {{group.count}}
    <ng-container *ngIf="group.count === 1">zábor</ng-container>
    <ng-container *ngIf="group.count >= 2 && group.count <= 4">zábory</ng-container>
    <ng-container *ngIf="group.count >= 5">záborů</ng-container>
    : {{group.reason}}
  </div>
</fieldset>
